import { action } from 'typesafe-actions'

import key from 'utils/localStorageKeys'
import { auth } from '../../api/AuthAPI'
import { ActionTypes } from './constants'
import type { AuthState } from './types'
import { v4 as uuidv4 } from 'uuid'
import { forgetServerPages } from 'utils/serverPages'
export const authenticateRequest = () => {
  return action(ActionTypes.AUTH_REQUEST)
}
export const updateToken = (token: string) => {}

export const updatUserSettingsSuccess = (settings: any) => {
  return action(ActionTypes.UPDATE_USER_SETTINGS_SUCCESS, {
    settings,
  })
}

export const setUserActive = (isUserActive: boolean) => {
  return action(ActionTypes.USER_ACTIVITY, {
    isUserActive,
  })
}
export const getUserSettingsSuccess = (settings: any) => {
  return action(ActionTypes.GET_USER_SETTINGS_SUCCESS, {
    settings,
  })
}

export const getUserProfileSuccess = (profile: { trade?: string; phoneNumber?: string }) => {
  return action(ActionTypes.GET_USER_PROFILE_SUCCESS, {
    profile,
  })
}

export const authenticateLogIn = (user: AuthState['user']) => {
  localStorage.setItem('sessionId', uuidv4())
  return action(ActionTypes.AUTH_LOG_IN, {
    user,
  })
}

export const authenticateError = (message: AuthState['error']) => {
  return action(ActionTypes.AUTH_ERROR, {
    message,
  })
}

export const authLogout = () => {
  auth.signOut()
  localStorage.removeItem('token')
  // Offline copies of this account's projects mustn't outlive the session; unsent edits stay, tagged by user.
  if ('caches' in window) for (const name of ['project-data', 'sheet-images']) void caches.delete(name)
  forgetServerPages()
  key.TOKEN = null
  return action(ActionTypes.AUTH_LOG_OUT)
}
